// © 2025 Camp Promethean, LLC. All Rights Reserved.

import { cn } from "@/lib/utils";

interface DashboardContentProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}

export function DashboardContent({
  children,
  className,
  fullWidth = false,
}: DashboardContentProps) {
  return (
    <div
      className={cn(
        "w-full p-4 md:p-6 flex flex-col min-h-0",
        !fullWidth && "mx-auto w-full max-w-7xl",
        className,
      )}
    >
      {children}
    </div>
  );
}
